import clsx from 'clsx';
import type { ReactElement } from 'react';

import type { SDSIconSize } from '@repo/sds/components/SDSIcon';
import { SDSIcon } from '@repo/sds/components/SDSIcon';
import type { SDSTextType } from '@repo/sds/components/SDSText';
import { SDSText } from '@repo/sds/components/SDSText';

import '@repo/sds/components/SDSTextBadge/SDSTextBadge.scss';

export interface SDSTextBadgeProps {
  color?: 'text-primary' | 'text-secondary' | 'primary' | 'secondary' | 'alert' | 'info' | 'warning';

  text: React.ReactNode;
  type: SDSTextType;
  icon: ReactElement;
  className?: string;
  background?: string;
  size: SDSIconSize;
  dataTestId?: string;
}

export function SDSTextBadge({
  color = 'text-primary',
  background,
  text,
  icon,
  type,
  className,
  size = 'small',
  dataTestId,
}: SDSTextBadgeProps) {
  const textClassName = clsx(
    'SDSTextBadge',
    {
      [`SDSTextBadge--${background}`]: background,
    },
    className,
  );
  return (
    <div className={textClassName} data-testid={dataTestId}>
      <SDSIcon icon={icon} color={color} size={size} />
      <SDSText text={text} type={type} color={color} />
    </div>
  );
}
